module.exports = __webpack_public_path__ + "assets/img/appreciation.dc59d194.jpg";